export default __webpack_public_path__ + "static/media/25.6d2b9582.jpg";